import { ArticleHeading4, Spinner, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './SubAgentSearch.css';
// @ts-expect-error TODO: исправить импорт картинок
import agentsImg from './assets/agents.png';
// @ts-expect-error TODO: исправить импорт картинок
import searchImg from './assets/search.png';

type TSubAgentSearchProps = {
  inputNode: React.ReactNode;
  subAgentsNode: React.ReactNode | null;
  errorNode: React.ReactNode | null;
  isLoading: boolean;
  isEmptySearch: boolean;
  isEmptyList: boolean;
  isTopTabsRedesigned: boolean;
};

export const SubAgentSearch: React.FC<TSubAgentSearchProps> = ({
  inputNode,
  subAgentsNode,
  errorNode,
  isLoading,
  isEmptySearch,
  isEmptyList,
  isTopTabsRedesigned,
}) => {
  return (
    <div className={isTopTabsRedesigned ? styles['container-redesigned'] : styles['container']}>
      {inputNode}
      {subAgentsNode}
      {isLoading && (
        <div className={styles['spinner']}>
          <Spinner size={16} />
        </div>
      )}
      {errorNode && <div className={styles['error']}>{errorNode}</div>}
      {isEmptySearch && (
        <div className={styles['empty']} data-name="SubAgentsSearchList_empty">
          <img src={searchImg} width={100} height={100} alt="Иконка поиска" />
          <ArticleHeading4>Не смогли найти сотрудника</ArticleHeading4>
          <UIText1 color="gray60_100">
            Возможно, вы опечатались: <br />
            попробуйте ещё раз
          </UIText1>
        </div>
      )}
      {isEmptyList && (
        <div className={styles['empty']} data-name="SubAgentsList_empty">
          <img src={agentsImg} width={130} height={100} alt="Иконка сотрудников" />
          <ArticleHeading4>Здесь будут чаты ваших сотрудников</ArticleHeading4>
          <UIText1 color="gray60_100">
            Вы пока не добавили ни одного <br />
            сотрудника
          </UIText1>
        </div>
      )}
    </div>
  );
};
